import React, { createContext, useContext, useEffect, useState } from "react";

const GlobalStateContext = createContext();

export const GlobalStateProvider = ({ children }) => {

  const [globalState, setGlobalState] = useState({
    user: null,
    token: null,
  });

  useEffect(() => {
    setGlobalState({
      user: JSON.parse(localStorage.getItem("rohit_rinku_user")),
      token: JSON.parse(localStorage.getItem("token")),
    });
  }, []);
  
  return <GlobalStateContext.Provider value={{ globalState, setGlobalState }}>{children}</GlobalStateContext.Provider>;
};
export const useGlobalState = () => {
  const context = useContext(GlobalStateContext);
  if (!context) {
    throw new Error("useGlobalState must be used within a GlobalStateProvider");
  }
  return context;
};
